( function( $ ) {

var pageId = 'page-member',
	page = '#' + pageId;

// $( function() {
//
// });

})( jQuery );
